import dayjs from 'dayjs'
import { computed } from 'vue'
//获取结束时间
const getLastTime = (time: any) => {
  const currDate = dayjs(Date.now()).format('YYYY-MM-DD')
  return currDate === time
    ? dayjs(Date.now()).format('YYYY-MM-DD HH:mm:ss')
    : dayjs(time).format('YYYY-MM-DD') + ' 23:59:59'
}
/* 日期+时间格式 */
export const queryTime = (date: any[]) => {
  return date?.length ? date : []
}

/* 日期格式 */
export const queryDate = (date: any[]) => {
  return date?.length ? [`${date[0].slice(0, 10)}`, `${getLastTime(date[1]).slice(0, 10)}`] : []
}

export const formatDate = (val?: number, format = 'YYYY-MM-DD HH:mm:ss') => {
  const formatVal = computed(() => {
    return val ? dayjs(val).format(format) : dayjs().format(format)
  })
  return formatVal.value.toString()
}

/**
 * 获取当前开始结束时间对象
 * @returns
 */
export const getStartAndEndDate = (formmat = 'YYYY-MM-DD') => {
  return {
    startDate: dayjs().subtract(1, 'day').format(formmat),
    endDate: dayjs().subtract(1, 'day').format(formmat)
  }
}
